"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CborText = exports.isRawCborText = void 0;
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var assert_1 = require("../utils/assert.js");
function isRawCborText(t) {
    if (typeof t !== "object" || t === null)
        return false;
    var keys = Object.keys(t);
    return (keys.includes("text") &&
        typeof t.text === "string");
}
exports.isRawCborText = isRawCborText;
var CborText = /** @class */ (function () {
    function CborText(text) {
        (0, assert_1.assert)(typeof text === "string", "invalid text in 'CborText' passed");
        (0, obj_utils_1.defineReadOnlyProperty)(this, "text", text);
    }
    CborText.prototype.toRawObj = function () {
        return {
            text: this.text
        };
    };
    CborText.prototype.clone = function () {
        return new CborText(this.text);
    };
    return CborText;
}());
exports.CborText = CborText;
